import { useEffect } from "react";

import type { Filter } from "../config/types";
import type {
  CompleteDateRange,
  StructuredSearchStore,
} from "../stores/structured-search/structured-search-store";

import { useStructuredSearchStore } from "@/components/StructuredSearch";

interface UseSyncStructuredSearchConstraintsInput {
  lockedFilters?: Filter[];
  dateRange?: CompleteDateRange;
  /** When false, skip locked-filter sync (parent owns locks). Defaults to true when lockedFilters is provided. */
  syncLockedFilters?: boolean;
  /** When false, skip date-range sync (parent owns date range). Defaults to true when dateRange is provided. */
  syncDateRange?: boolean;
  store?: StructuredSearchStore;
}

export const useSyncStructuredSearchConstraints = ({
  lockedFilters,
  dateRange,
  syncLockedFilters = lockedFilters !== undefined,
  syncDateRange = dateRange !== undefined,
  store: storeProp,
}: UseSyncStructuredSearchConstraintsInput) => {
  const storeFromContext = useStructuredSearchStore();
  const store = storeProp ?? storeFromContext;

  useEffect(() => {
    if (!syncLockedFilters || lockedFilters === undefined) {
      return;
    }
    store.setLockedFilters(lockedFilters);
  }, [lockedFilters, store, syncLockedFilters]);

  useEffect(() => {
    if (!syncDateRange || !dateRange) {
      return;
    }
    store.setDateRange(dateRange);
  }, [dateRange, store, syncDateRange]);
};
